import instance from "../interceptors/AxiosInterceptor";

const BASE_URL = "/api/reports";

const reportService = {
  exportReport: async (format, body) => {
    try {
      const response = await instance.post(
        `${BASE_URL}/export/${format}`,
        body,
        {
          withCredentials: true,
          responseType: "blob", 
        }
      );
      return response.data; 
    } catch (error) {
      throw error;
    }
  },
};

export default reportService;
